import { graphql } from "~/gql";

export const DISCOUNT_FRAGMENT = graphql(/* GraphQL */ `
  fragment DiscountParts on Discount {
    __typename
    autoFocus @client
    id
    reason
    amount
    type
    order
  }
`);
